// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Brand Color Variables */
:root {
  /* Primary Brand Colors */
  --brand-primary-pink: #E03A80;
  --brand-primary-blue: #4653D1;
  --brand-gradient: linear-gradient(135deg, #E03A80 0%, #4653D1 100%);
  --brand-gradient-hover: linear-gradient(135deg, #C73070 0%, #3A47B8 100%);
  
  /* Secondary Colors */
  --brand-light-gray: #EDEDED;
  --brand-black: #000000;
  --brand-white: #FFFFFF;
  
  /* Override Bootstrap Primary Colors */
  --bs-primary: #E03A80;
  --bs-primary-rgb: 224, 58, 128;
  --bs-secondary: #4653D1;
  --bs-secondary-rgb: 70, 83, 209;
}

/* Brand Button Styles */
.btn-brand-primary {
  background: var(--brand-gradient) !important;
  border: none !important;
  color: var(--brand-white) !important;
  transition: all 0.3s ease !important;
}

.btn-brand-primary:hover,
.btn-brand-primary:focus,
.btn-brand-primary:active {
  background: var(--brand-gradient-hover) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 15px rgba(224, 58, 128, 0.3) !important;
  color: var(--brand-white) !important;
}

.btn-brand-secondary {
  background: var(--brand-light-gray) !important;
  border: 1px solid var(--brand-light-gray) !important;
  color: var(--brand-black) !important;
  transition: all 0.3s ease !important;
}

.btn-brand-secondary:hover,
.btn-brand-secondary:focus,
.btn-brand-secondary:active {
  background: var(--brand-gradient) !important;
  border: none !important;
  color: var(--brand-white) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 15px rgba(224, 58, 128, 0.3) !important;
}

.btn-brand-outline {
  background: transparent !important;
  border: 2px solid var(--brand-primary-pink) !important;
  color: var(--brand-primary-pink) !important;
  transition: all 0.3s ease !important;
}

.btn-brand-outline:hover,
.btn-brand-outline:focus,
.btn-brand-outline:active {
  background: var(--brand-gradient) !important;
  border: 2px solid transparent !important;
  color: var(--brand-white) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 15px rgba(224, 58, 128, 0.3) !important;
}

/* Brand Text Styles */
.text-brand-primary {
  background: var(--brand-gradient);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 600;
}

.text-brand-pink {
  color: var(--brand-primary-pink) !important;
}

.text-brand-blue {
  color: var(--brand-primary-blue) !important;
}

/* Brand Background Styles */
.bg-brand-gradient {
  background: var(--brand-gradient) !important;
}

.bg-brand-light {
  background: var(--brand-light-gray) !important;
}

.bg-brand-pink {
  background: var(--brand-primary-pink) !important;
}

.bg-brand-blue {
  background: var(--brand-primary-blue) !important;
}

/* Override Bootstrap Primary Classes */
.btn-primary {
  background: var(--brand-gradient) !important;
  border: none !important;
  color: var(--brand-white) !important;
  transition: all 0.3s ease !important;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active {
  background: var(--brand-gradient-hover) !important;
  border: none !important;
  color: var(--brand-white) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 15px rgba(224, 58, 128, 0.3) !important;
}

.text-primary {
  color: var(--brand-primary-pink) !important;
}

.bg-primary {
  background: var(--brand-gradient) !important;
}

.border-primary {
  border-color: var(--brand-primary-pink) !important;
}

/* Brand Badges */
.badge.bg-primary {
  background: var(--brand-gradient) !important;
  color: var(--brand-white) !important;
}

.badge.bg-warning {
  background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%) !important;
  color: var(--brand-black) !important;
}

/* Brand Navigation Active States */
.nav-link.active {
  color: var(--brand-primary-pink) !important;
  font-weight: 600 !important;
}

.dropdown-item.active {
  background: var(--brand-gradient) !important;
  color: var(--brand-white) !important;
}

/* Brand Cards and Components */
.card-primary {
  border-color: var(--brand-primary-pink) !important;
}

.card-primary .card-header {
  background: var(--brand-gradient) !important;
  color: var(--brand-white) !important;
}

/* Brand Form Controls */
.form-control:focus {
  border-color: var(--brand-primary-pink) !important;
  box-shadow: 0 0 0 0.2rem rgba(224, 58, 128, 0.25) !important;
}

/* Brand Icons */
.fa-check.text-primary {
  color: var(--brand-primary-pink) !important;
}

.fa-coins,
.fa-video,
.fa-star,
.fa-gift,
.fa-heart,
.fa-crown {
  color: var(--brand-primary-pink) !important;
}

/* Pricing Card Enhancements */
.pricing-item {
  transition: all 0.3s ease !important;
  border: 1px solid var(--brand-light-gray) !important;
}

.pricing-item:hover {
  transform: translateY(-5px) !important;
  box-shadow: 0 10px 30px rgba(224, 58, 128, 0.2) !important;
}

/* Brand Animations */
@keyframes brandGradientShift {
  0% { 
    background-position: 0% 50%; 
  }
  50% { 
    background-position: 100% 50%; 
  }
  100% { 
    background-position: 0% 50%; 
  }
}

.animate-gradient {
  background: linear-gradient(-45deg, #E03A80, #4653D1, #E03A80, #4653D1);
  background-size: 400% 400%;
  animation: brandGradientShift 3s ease infinite;
}
`, "",{"version":3,"sources":["webpack://./src/styles/brand-colors.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B;EAC7B,mEAAmE;EACnE,yEAAyE;;EAEzE,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;EACtB,sBAAsB;;EAEtB,sCAAsC;EACtC,qBAAqB;EACrB,8BAA8B;EAC9B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA,wBAAwB;AACxB;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;;EAGE,kDAAkD;EAClD,sCAAsC;EACtC,yDAAyD;EACzD,oCAAoC;AACtC;;AAEA;EACE,8CAA8C;EAC9C,oDAAoD;EACpD,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;;EAGE,4CAA4C;EAC5C,uBAAuB;EACvB,oCAAoC;EACpC,sCAAsC;EACtC,yDAAyD;AAC3D;;AAEA;EACE,kCAAkC;EAClC,sDAAsD;EACtD,2CAA2C;EAC3C,oCAAoC;AACtC;;AAEA;;;EAGE,4CAA4C;EAC5C,wCAAwC;EACxC,oCAAoC;EACpC,sCAAsC;EACtC,yDAAyD;AAC3D;;AAEA,sBAAsB;AACtB;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,4BAA4B;AAC5B;EACE,4CAA4C;AAC9C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA,uCAAuC;AACvC;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;;;;EAIE,kDAAkD;EAClD,uBAAuB;EACvB,oCAAoC;EACpC,sCAAsC;EACtC,yDAAyD;AAC3D;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,kDAAkD;AACpD;;AAEA,iBAAiB;AACjB;EACE,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA;EACE,wEAAwE;EACxE,oCAAoC;AACtC;;AAEA,mCAAmC;AACnC;EACE,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA,+BAA+B;AAC/B;EACE,kDAAkD;AACpD;;AAEA;EACE,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,kDAAkD;EAClD,4DAA4D;AAC9D;;AAEA,gBAAgB;AAChB;EACE,2CAA2C;AAC7C;;AAEA;;;;;;EAME,2CAA2C;AAC7C;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,oDAAoD;AACtD;;AAEA;EACE,sCAAsC;EACtC,0DAA0D;AAC5D;;AAEA,qBAAqB;AACrB;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,uEAAuE;EACvE,0BAA0B;EAC1B,8CAA8C;AAChD","sourcesContent":["/* Brand Color Variables */\n:root {\n  /* Primary Brand Colors */\n  --brand-primary-pink: #E03A80;\n  --brand-primary-blue: #4653D1;\n  --brand-gradient: linear-gradient(135deg, #E03A80 0%, #4653D1 100%);\n  --brand-gradient-hover: linear-gradient(135deg, #C73070 0%, #3A47B8 100%);\n  \n  /* Secondary Colors */\n  --brand-light-gray: #EDEDED;\n  --brand-black: #000000;\n  --brand-white: #FFFFFF;\n  \n  /* Override Bootstrap Primary Colors */\n  --bs-primary: #E03A80;\n  --bs-primary-rgb: 224, 58, 128;\n  --bs-secondary: #4653D1;\n  --bs-secondary-rgb: 70, 83, 209;\n}\n\n/* Brand Button Styles */\n.btn-brand-primary {\n  background: var(--brand-gradient) !important;\n  border: none !important;\n  color: var(--brand-white) !important;\n  transition: all 0.3s ease !important;\n}\n\n.btn-brand-primary:hover,\n.btn-brand-primary:focus,\n.btn-brand-primary:active {\n  background: var(--brand-gradient-hover) !important;\n  transform: translateY(-2px) !important;\n  box-shadow: 0 4px 15px rgba(224, 58, 128, 0.3) !important;\n  color: var(--brand-white) !important;\n}\n\n.btn-brand-secondary {\n  background: var(--brand-light-gray) !important;\n  border: 1px solid var(--brand-light-gray) !important;\n  color: var(--brand-black) !important;\n  transition: all 0.3s ease !important;\n}\n\n.btn-brand-secondary:hover,\n.btn-brand-secondary:focus,\n.btn-brand-secondary:active {\n  background: var(--brand-gradient) !important;\n  border: none !important;\n  color: var(--brand-white) !important;\n  transform: translateY(-2px) !important;\n  box-shadow: 0 4px 15px rgba(224, 58, 128, 0.3) !important;\n}\n\n.btn-brand-outline {\n  background: transparent !important;\n  border: 2px solid var(--brand-primary-pink) !important;\n  color: var(--brand-primary-pink) !important;\n  transition: all 0.3s ease !important;\n}\n\n.btn-brand-outline:hover,\n.btn-brand-outline:focus,\n.btn-brand-outline:active {\n  background: var(--brand-gradient) !important;\n  border: 2px solid transparent !important;\n  color: var(--brand-white) !important;\n  transform: translateY(-2px) !important;\n  box-shadow: 0 4px 15px rgba(224, 58, 128, 0.3) !important;\n}\n\n/* Brand Text Styles */\n.text-brand-primary {\n  background: var(--brand-gradient);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-weight: 600;\n}\n\n.text-brand-pink {\n  color: var(--brand-primary-pink) !important;\n}\n\n.text-brand-blue {\n  color: var(--brand-primary-blue) !important;\n}\n\n/* Brand Background Styles */\n.bg-brand-gradient {\n  background: var(--brand-gradient) !important;\n}\n\n.bg-brand-light {\n  background: var(--brand-light-gray) !important;\n}\n\n.bg-brand-pink {\n  background: var(--brand-primary-pink) !important;\n}\n\n.bg-brand-blue {\n  background: var(--brand-primary-blue) !important;\n}\n\n/* Override Bootstrap Primary Classes */\n.btn-primary {\n  background: var(--brand-gradient) !important;\n  border: none !important;\n  color: var(--brand-white) !important;\n  transition: all 0.3s ease !important;\n}\n\n.btn-primary:hover,\n.btn-primary:focus,\n.btn-primary:active,\n.btn-primary.active {\n  background: var(--brand-gradient-hover) !important;\n  border: none !important;\n  color: var(--brand-white) !important;\n  transform: translateY(-2px) !important;\n  box-shadow: 0 4px 15px rgba(224, 58, 128, 0.3) !important;\n}\n\n.text-primary {\n  color: var(--brand-primary-pink) !important;\n}\n\n.bg-primary {\n  background: var(--brand-gradient) !important;\n}\n\n.border-primary {\n  border-color: var(--brand-primary-pink) !important;\n}\n\n/* Brand Badges */\n.badge.bg-primary {\n  background: var(--brand-gradient) !important;\n  color: var(--brand-white) !important;\n}\n\n.badge.bg-warning {\n  background: linear-gradient(135deg, #FFD700 0%, #FFA500 100%) !important;\n  color: var(--brand-black) !important;\n}\n\n/* Brand Navigation Active States */\n.nav-link.active {\n  color: var(--brand-primary-pink) !important;\n  font-weight: 600 !important;\n}\n\n.dropdown-item.active {\n  background: var(--brand-gradient) !important;\n  color: var(--brand-white) !important;\n}\n\n/* Brand Cards and Components */\n.card-primary {\n  border-color: var(--brand-primary-pink) !important;\n}\n\n.card-primary .card-header {\n  background: var(--brand-gradient) !important;\n  color: var(--brand-white) !important;\n}\n\n/* Brand Form Controls */\n.form-control:focus {\n  border-color: var(--brand-primary-pink) !important;\n  box-shadow: 0 0 0 0.2rem rgba(224, 58, 128, 0.25) !important;\n}\n\n/* Brand Icons */\n.fa-check.text-primary {\n  color: var(--brand-primary-pink) !important;\n}\n\n.fa-coins,\n.fa-video,\n.fa-star,\n.fa-gift,\n.fa-heart,\n.fa-crown {\n  color: var(--brand-primary-pink) !important;\n}\n\n/* Pricing Card Enhancements */\n.pricing-item {\n  transition: all 0.3s ease !important;\n  border: 1px solid var(--brand-light-gray) !important;\n}\n\n.pricing-item:hover {\n  transform: translateY(-5px) !important;\n  box-shadow: 0 10px 30px rgba(224, 58, 128, 0.2) !important;\n}\n\n/* Brand Animations */\n@keyframes brandGradientShift {\n  0% { \n    background-position: 0% 50%; \n  }\n  50% { \n    background-position: 100% 50%; \n  }\n  100% { \n    background-position: 0% 50%; \n  }\n}\n\n.animate-gradient {\n  background: linear-gradient(-45deg, #E03A80, #4653D1, #E03A80, #4653D1);\n  background-size: 400% 400%;\n  animation: brandGradientShift 3s ease infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
